import TelNumberField from '@/components/fields/tel-number-field.vue';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
export default {
    components : {
        TelNumberField
    },
    mixins: [validationMixin],

    validations: {
        email                   : { required, email },
        selectNotificationType  : { required },
        formNotification        : [
            'email',
            'selectNotificationType'
        ]
    },
    props: {
        jsonDebug   :  {
            type    : Boolean,
            default : true
        },
        values : {
            type    : Object,
            default : function () { return {}; }
        }
    },
    data: () => ({
        email : null,
        selectNotificationType  : {
            // type : null,
            // icon : null
        },
        notificationTypes       : [
            {
                type : 1,
                icon : 'mdi-phone'
            },{
                type : 2,
                icon : 'mdi-fax'
            },{
                type : 3,
                icon : 'mdi-message-bulleted'
            },{
                type : 4,
                icon : 'mdi-email'
            },{
                type : 5,
                icon : 'mdi-post'
            }
        ]
    }),
    methods : {
        validateForm() {
            this.$v.formNotification.$touch();
            // this.$v.selectNotificationType.$touch();
            let errors = false;

            if (this.$v.formNotification.$anyError)  {
                errors = true;
            }

            if (this.$refs.numTelefon.required && !this.$refs.numTelefon.validate()) {
                console.error('numTelefon is not valid!');
                errors = true;
            }
            if (this.$refs.numFax.required && !this.$refs.numFax.validate()) {
                console.error('numFax is not valid!');
                errors = true;
            }
            if (this.$refs.numMobile.required && !this.$refs.numMobile.validate()) {
                console.error('numMobile is not valid!');
                errors = true;
            }

            if (errors) {
                this.$emit('form-notification-has-errors');
                return false;
            } else {
                this.$emit('form-notification-is-valid');
                return true;
            }
        },
        onChangeSelectedNotificationType(val) {
            console.info('onChangeSelectedNotificationType', this.values, val);
            if (!val) {
                console.info('no value', val);
                this.selectNotificationType  = null;
                // this.selectNotificationType  = {
                //     type : null,
                //     icon : null
                // };
            }
            if (this.values) {
                this.setFormValues(this.values);
            }
        },
        onValidateFields() {
            console.warn('onValidateFields', this.$refs);
            if (this.$v.formNotification.$dirty) {
                this.validateForm();
            } else {
                return;
            }
        },
        resetForm() {
            if (this.$v.formNotification.$dirty) {
                this.$v.formNotification.$reset();
                this.$refs.numTelefon.reset();
                this.$refs.numFax.reset();
                this.$refs.numMobile.reset();
                this.email = '';
                this.$emit('form-notification-is-valid');
            }
        },
        getFormValues() {
            let ret = {};
            ret.type        = this.selectNotificationType;
            switch(selectNotificationType.type) {
                case 1:
                    ret.numTelefon  = this.$refs.numTelefon.getValue();
                    break;
                case 2:
                    ret.numFax  = this.$refs.numFax.getValue();
                    break;
                case 3:
                    ret.numMobile  = this.$refs.numMobile.getValue();
                    break;
                case 4:
                    ret.email  = this.email;
                    break;
                // case 5:
                    // break;
                default:
                    return ret;
            }

            return ret;
        },
        setFormValues(data) {
            console.info('data', data);
            if (data.phone) {
                this.$refs.numTelefon.setValue(data.phone);
            }
            if (data.fax) {
                this.$refs.numFax.setValue(data.fax);
            }
            if (data.mobile) {
                this.$refs.numMobile.setValue(data.mobile);
            }
            if (data.email) {
                this.email      = data.email;
            }
        },
    },
    watch: {
        '$v.formNotification.$anyError' : function(errors) {
            console.error('anyError notification', errors);
            if (errors) {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing xxx
                this.$emit('form-notification-has-errors');
            } else {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing
                this.$emit('form-notification-is-valid');

            }
        },
        '$v.formNotification.$dirty' : function(dirty) {
            console.error('dirty notification', dirty);
            if (!dirty && !this.$v.formNotification.$anyError) {
            // if (!dirty) {
                console.warn(this.$v);
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing
                this.$emit('form-notification-is-valid');
            } else {
                if (this.$v.formCommunication.$anyError) {
                    // Fire when the form is cleared
                    // @arg The argument is a boolean value representing xxx
                    this.$emit('form-notification-has-errors');
                }
            }
        }
    },
    computed: {
        emailErrors() {
            const errors = [];
            if (!this.$v.email.$dirty) {
                return errors;
            }
            if (!this.$v.email.email) {
                errors.push('Must be valid e-mail');
            }
            if (!this.$v.email.required) {
                errors.push('E-mail is required');
            }
            return errors;
        },
        selectNotificationTypeErrors() {
            const errors = [];
            if (!this.$v.selectNotificationType.$dirty) {
                return errors;
            }
            if (!this.$v.selectNotificationType.required) {
                errors.push('selectNotificationType is required');
            }
            return errors;
        },
    },
};
